<template>
  <div id="app">
    <reseller-header />
    <router-view :key="$route.fullPath" />
    <reseller-footer />
  </div>
</template>

<script>
import ResellerHeader from '@/layout/Header.vue';
import ResellerFooter from '@/layout/Footer.vue';
export default {
  components: {
    ResellerHeader,
    ResellerFooter
  }
};
</script>
<style lang="scss">
//@import "./assets/styles/main.scss";
#app {
  min-width: 1000px;
}
</style>
